import { useCallback, useEffect, useState } from 'react';
import gamesService from '../../../../services/gamesService';
import type { GameMissingPlu } from '../../../../types/features/games';

export const useGamesMissingPlu = () => {
  const [games, setGames] = useState<GameMissingPlu[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await gamesService.getGamesMissingPlu();
      setGames(response.data || []);
    } catch (loadError) {
      setError(loadError instanceof Error ? loadError.message : 'Failed to load games missing PLU');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { void reload(); }, [reload]);

  return { games, loading, error, reload };
};
